

































































/**
 * External dependencies.
 */
import Component, { mixins } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

/**
 * Internal dependencies.
 */
import PhotosHelperMixin from '@/mixins/PhotosHelperMixin.vue'
import IsotopePhotos from '@/components/account/renderless/IsotopePhotos.vue'
import { isSafariBrowser } from '@/utils/helpers'

import { namespace as commonModule } from '@/store/common'
import { Modes } from '@/store/common/enum/Modes'

@Component({
  components: { IsotopePhotos }
})
export default class ProfileFavorites extends mixins(PhotosHelperMixin) {
  @Prop(Array) profileResults!: Array<any> | object
  @Prop(Boolean) isMyProfile!: boolean
  @Prop(Boolean) isLoading!: boolean

  @commonModule.Getter getCurrentCycleYear: number
  @commonModule.Getter getMode: Modes

  isCompleted: boolean = false

  isSafariBrowser () {
    return isSafariBrowser()
  }

  created () {
    this.isCompleted = this.getMode === Modes.COMPLETED
  }
}
